import _get from 'lodash/get';
import type {
  UpdateWeddingRequest,
  WWeddingView,
  WWeddingAccountView,
  WThemeGroupView,
} from '@zola/svc-web-api-ts-client';

export type WeddingType = UpdateWeddingRequest & WWeddingView;
export interface WeddingState {
  wedding: WeddingType;
  account: WWeddingAccountView;
  theme: WThemeGroupView;
}
export interface RootState {
  wedding: WeddingState;
}

export const getWedding = (state: RootState): WWeddingView => state.wedding.wedding || {};

export const getWeddingAccount = (state: RootState): WWeddingAccountView => state.wedding.account;

export const getWeddingWebsiteVisibility = (state: RootState) =>
  state.wedding?.account?.published || false;

export const getWeddingAccountHash = (state: RootState): string | undefined =>
  state.wedding.account.hash_id;

export const getEnableV2Website = (state: RootState): boolean =>
  state.wedding.account.enable_website_v2 || false;

export const getTheme = (state: RootState): WThemeGroupView => _get(state, 'wedding.theme', {});

export const getWeddingAccountUUID = (state: RootState): string =>
  _get(state, 'wedding.account.uuid', '');

// Swatch_2 precedence over swatch_1. See src/components/manage/website/ThemeSwatches
export const getThemeHexColor = (state: RootState): string | undefined => {
  const swatch1 = _get(state, 'wedding.theme.swatch_color_1', '');
  const swatch2 = _get(state, 'wedding.theme.swatch_color_2', '');
  return swatch2 || swatch1;
};

export const getThemeGroupTitle = (state: RootState): string | undefined =>
  _get(state, 'state.wedding.themeGroupTitle', {});

export default getWedding;
